import React from 'react';
import { ChevronDown } from 'lucide-react';
import { useCurrency } from '../context/CurrencyContext';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuLabel,
} from './ui/dropdown-menu';

const OPTIONS = { INR: { flag: '🇮🇳', label: 'INR · Indian Rupee', short: '₹ INR' }, USD: { flag: '🌐', label: 'USD · US Dollar', short: '$ USD' } };

export const CurrencySwitcher = ({ compact = false, testId = 'currency-switcher', disabled = false }) => {
  const { currency, setCurrency, currencies, loading } = useCurrency();
  const cur = OPTIONS[currency] || OPTIONS.USD;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button data-testid={`${testId}-trigger`} disabled={loading || disabled} aria-label={loading ? 'Loading currency' : `Currency: ${cur.label}`} className="inline-flex min-h-[40px] items-center gap-1.5 rounded-full border border-border bg-white px-3 text-sm font-medium text-primary transition-colors hover:border-primary/30 disabled:opacity-60">
          <span aria-hidden="true">{loading ? '…' : cur.flag}</span>
          <span className={compact ? 'hidden sm:inline' : ''}>{loading ? 'Currency' : cur.short}</span>
          <ChevronDown className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel className="text-xs text-muted-foreground">Prices shown in</DropdownMenuLabel>
        {currencies.map((c) => (
          <DropdownMenuItem key={c} data-testid={testId === 'currency-switcher' ? `currency-option-${c}` : `${testId}-option-${c}`} onClick={() => setCurrency(c)} className={`cursor-pointer gap-2 ${c === currency ? 'bg-muted font-semibold' : ''}`}>
            <span aria-hidden="true">{OPTIONS[c].flag}</span> {OPTIONS[c].label}
          </DropdownMenuItem>
        ))}
        <a href="https://db-ip.com" target="_blank" rel="noreferrer" data-testid={`${testId}-geo-attribution`} className="block px-2 py-2 text-[10px] text-muted-foreground hover:underline">IP Geolocation by DB-IP</a>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
